import { render, staticRenderFns } from "./ConfirmDialogSmall.vue?vue&type=template&id=830e86fc"
import script from "./ConfirmDialogSmall.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports